export default __webpack_public_path__ + "static/power_iot-c0a5d5223e019b8803a39e357e9e848f.webp";